import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { costRows } from '../data/comparaciones';
import { Emoji } from './Emoji';
export function CostoDeNoTenerlo() {
  return <section className="w-full bg-forest-800 py-14 sm:py-16" data-id="element-49" data-mp="2f7z3npcar9mj">
      <div className="mx-auto w-full max-w-[680px] px-4 text-center sm:px-6 lg:max-w-[980px]" data-id="element-50" data-mp="2f7h34gilq98t">
        <h2 className="inline-flex flex-wrap items-center justify-center gap-2 font-display text-[clamp(1.5rem,6vw,2.25rem)] font-extrabold leading-[1.08] tracking-tight text-cream" data-id="element-51" data-mp="2k5iiorgtjqfj">
          <Emoji symbol="⚖️" className="text-3xl" data-id="element-52" data-mp="2a9nvdj1nh76f" />
          ¿Cuánto cuesta NO tenerlo?
        </h2>

        <ul className="mt-9 grid gap-3 text-left lg:grid-cols-2" data-id="element-53" data-mp="1wisgnq4gzvux">
          {costRows.map(row => <li key={row.situation} className="rounded-2xl border border-line bg-pistacho px-4 py-4 sm:px-5 sm:py-5" data-id="element-54" data-mp="20jvuy86vdju1">
              <p className="text-[14px] font-medium text-forest-800 sm:text-[15px]" data-id="element-55" data-mp="1rixrbr0cfebz">
                {row.situation}
              </p>
              <p className="mt-3 flex items-start gap-2 text-[14px] font-bold text-clay sm:text-[15px]" data-id="element-56" data-mp="1bfxeyjf74neo">
                <ArrowDownIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-57" data-mp="16hnkyc57jsun" />
                <span className="min-w-0" data-id="element-58" data-mp="1fiu3srvbxfr2">{row.cost}</span>
              </p>
            </li>)}
        </ul>

        <p className="mt-11 font-display text-[clamp(1.25rem,5vw,1.875rem)] font-extrabold tracking-tight text-cream" data-id="element-59" data-mp="rsrf8lqmirx7">
          El Mega Pack Cocina Lista cuesta menos que dos semanas de delivery.
        </p>
        <p className="mt-3 font-display text-lg font-bold text-lime-400 sm:text-xl" data-id="element-60" data-mp="11jcaq0b03gbw">
          Y dura para siempre.
        </p>
      </div>
    </section>;
}